import api from './api';

export const authService = {
  register: async (formData) => {
    return await api.post('/auth/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  verifyEmail: async (token) => {
    return await api.post('/auth/verify-email', { token });
  },

  login: async (credentials, userType = 'merchant') => {
    // Route to different endpoints based on user type
    const endpoints = {
      admin: '/admin/auth/login',
      merchant: '/auth/login',
      customer: '/customer/auth/login'
    };

    const endpoint = endpoints[userType] || endpoints.merchant;

    // Transform credentials for customer login (mobile instead of username)
    let loginData = credentials;
    if (userType === 'customer') {
      loginData = {
        mobile: credentials.username,
        password: credentials.password
      };
    }

    return await api.post(endpoint, loginData);
  },

  forgotPassword: async (email) => {
    return await api.post('/auth/forgot-password', { email });
  },

  resetPassword: async (token, newPassword) => {
    return await api.post('/auth/reset-password', { token, newPassword });
  },

  loadUser: async (userType = 'merchant') => {
    // Route to different endpoints based on user type
    const endpoints = {
      admin: '/admin/me',
      merchant: '/merchants/me',
      customer: '/customer/auth/me'
    };

    const endpoint = endpoints[userType] || endpoints.merchant;
    return await api.get(endpoint);
  }
};
